// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateId } from './TestTemplate';
import { testAttributeCodeCode } from './TestAttributeCode';
import { operatorId } from './Operator';
import { z } from 'zod';
export const calibrationCurveId = (z.number());
export const calibrationCurve = z.object({
    id: calibrationCurveId,
    test_template_id: testTemplateId,
    analyte_code: testAttributeCodeCode,
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const calibrationCurveInitializer = z.object({
    id: calibrationCurveId.optional(),
    test_template_id: testTemplateId,
    analyte_code: testAttributeCodeCode,
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const calibrationCurveMutator = z.object({
    id: calibrationCurveId.optional(),
    test_template_id: testTemplateId.optional(),
    analyte_code: testAttributeCodeCode.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=CalibrationCurve.js.map